import { useCallback, useEffect, useState } from 'react';
// import { BehaviorSubject } from 'rxjs';
import { isLogged, clearAccessToken } from 'services/auth';
import { myProfile, MyProfile } from 'api/auth/user-profile';
import { logout as logoutApi } from 'api/auth/logout.api';
import { useRouter } from './use-router.hook';
import { userPermissionSubject } from 'services/user-permission';
import { userSessionSubject } from 'services/user-permission/user-permission';

export interface UserSession {
  isLoggedIn: boolean;
  userInfo?: MyProfile;
}

let isFetchingUserData = false;

function getUserInfo(logout: () => void, isForceUpdateData = false) {
  const userData = userSessionSubject.getValue();
  const shouldNotCallApi = userData || isFetchingUserData;

  if (shouldNotCallApi && !isForceUpdateData) return;

  isFetchingUserData = true;

  myProfile().subscribe({
    next: (res) => {
      const userRightMap = JSON.parse(res.data.userRights);

      userSessionSubject.next(res.data);

      userPermissionSubject.next(userRightMap);
    },
    error: (err) => {
      if (err.status === 401) logout();
    },
  });
}

export function useSession() {
  const router = useRouter();
  const [isLoggedIn, setIsLoggedIn] = useState(isLogged());
  const [userInfo, setUserInfo] = useState<MyProfile>();

  const logout = useCallback(() => {
    const onLogout = () => {
      removeAllLoading();
      isFetchingUserData = false;
      clearAccessToken();
      userSessionSubject.next(undefined);
      router.navigate('/auth/login');
    };

    logoutApi().subscribe({
      next: () => onLogout(),
      error: () => onLogout(),
    });
  }, [router]);

  useEffect(() => {
    const isLoggedIn = isLogged();

    userSessionSubject.subscribe((data) => {
      setUserInfo(data);
    });

    setIsLoggedIn(isLoggedIn);

    isLoggedIn && getUserInfo(logout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const syncDataWithServer = useCallback((isForceUpdateData = false) => {
    const isLoggedIn = isLogged();

    isLoggedIn && getUserInfo(logout, isForceUpdateData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { isLoggedIn, userInfo, logout, syncDataWithServer };
}
